import React, {useState, useEffect} from 'react';
import { DndContext, DragOverlay, DragOverEvent } from '@dnd-kit/core';
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import Skeleton from 'react-loading-skeleton';

import { PProFetch, PProPost } from '../ajax';

import { Trash } from './Trash.js'
import { DnDContainer } from './DnDContainer.js'
import { Item } from "./Product.js";
import { BuildSelect } from './FPUtil.js'

export default function ProfileMaintenance() {
	const [fpInfo, setFpInfo] = useState({
		root: {
			// Styles to hide things
			HIDEINSERT: null,
			SHOWALLCLS: null,
			CLASSHIDDEN: null,
			COMMHIDDEN: null,
			// Piped lists 
			PIPED_PROFILE: null,
			PIPED_PROFILE_DESCR: null,
			PIPED_CATALOG: null,
			PIPED_CATALOG_DESCR: null,
			PIPED_CATALOG_COMMODITY: null, // TODO unused??
			PIPED_CATALOG_CLASS: null, // TODO unused??
			// Values for <select> filters
			CLASSSEARCH: null,
			COMMODITY_DROPDOWN: null
		},
		rowData: { }
	});
	const [loading, setLoading] = useState(true);
	const [message, setMessage] = useState("");
	const [catalogItemsArray, setCatalogItemsArray] = useState([]);
	const [profileItemsArray, setProfileItemsArray] = useState([]);
	const [searchText, setSearchText] = useState("");
	const [activeDragItem, setActiveDragItem] = useState();

	const updateStateFromAjax = (json) => {		
		setFpInfo({...json});
		setLoading(false);
		_handleCatalogItemsArray(json);
	}

	useEffect(() => {
		setLoading(true);
		PProFetch("command=ProfileMaintenanceHandler.optionsreact")
		.then(response => {
			return response.json();
		})
		.then(json => {
			updateStateFromAjax(json);
			_handleProfileItemsArray(json);
		});
	}, []);

	const _getArrayIndex = (array, id) => {
		for (let j = 0; j < array.length; j++) {
			if (array[j].id == id) {
				return j;
			}
		}
		return -1; // no match
	}

	const _getItemsArray = (items, itemDescrs, bProfile = true) => {
		let profileOrCatalogItems = [];
		for (let i = 0; i < items.length; i++) {
			if (bProfile === false && _getArrayIndex(profileItemsArray, items[i]) != -1) {
				console.log("Skipping catalog product " + items[i] + ". Already in profile");
				continue;
			}
			profileOrCatalogItems.push({
				id: items[i],
				text: itemDescrs[i],
				source: bProfile ? "profile" : "catalog"
			});
		}
		return profileOrCatalogItems;
	}
	const _handleProfileItemsArray = (fpInfo) => {
		if (!fpInfo.root.PIPED_PROFILE?.value) {
			console.log("no fpInfo, called setProfileItemsArray");
			return;
		}
		const item = fpInfo.root.PIPED_PROFILE.value.split("|");
		const itemDescr = fpInfo.root.PIPED_PROFILE_DESCR.value.split("|");
		const itemArray = _getItemsArray(item, itemDescr);
		setProfileItemsArray(itemArray);
	}
	const _handleCatalogItemsArray = (fpInfo) => {
		if (!fpInfo.root.PIPED_CATALOG?.value) {
			console.log("no fpInfo, called setCatalogItemsArray");
			return;
		}
		const item = fpInfo.root.PIPED_CATALOG.value.split("|");
		const itemDescr = fpInfo.root.PIPED_CATALOG_DESCR.value.split("|");
		const itemArray = _getItemsArray(item, itemDescr, false);
		setCatalogItemsArray(itemArray);
	}

	const pmSearchOnEnterKey = (event) => {
		var code = Ecom2.getEventCode(event);
		if (code == 40 || code == 13) {
			profileMaintSearch();
			return false;
		}
		return true;
	};

	const profileMaintSearch = () => {
		try { document.getElementById(fpInfo.root.COMMODITY_DROPDOWN.id).selectedIndex = 0; } catch(e1) {} 
		try { document.getElementById(fpInfo.root.CLASSSEARCH.id).selectedIndex = 0; } catch(e2) {} 
		let value = Ecom2.PProUtil.addZerosToProductNum(searchText);
		if (!Ecom2.PProProfile.preCheckCatalogSearch(value, true)) {
			setMessage("Please use at least 3 characters for the search criteria.");
			return false;
		} 
		setMessage("");
		profMaintSearch("searchText", value);               
	};

	const profileMaintSearchAll = () => {
		try { document.getElementById(fpInfo.root.COMMODITY_DROPDOWN.id).selectedIndex = 0; } catch(e1) {} 
		try { document.getElementById(fpInfo.root.CLASSSEARCH.id).selectedIndex = 0; } catch(e2) {} 
		profMaintSearch("searchText", "**GETALL**");               
	};

	const pmCommSearch = () => {
		setSearchText("");
		let value = document.getElementById(fpInfo.root.COMMODITY_DROPDOWN.id).value;
		profMaintSearch("COMMODITY_SEARCH", value);
	};

	const pmClassSearch = () => {
		setSearchText("");
		var value = document.getElementById(fpInfo.root.CLASSSEARCH.id).value;
		profMaintSearch("CLASSSEARCH", value);
	};

	const profMaintSearch = (parm, value) => {
		if (value === "") {
			return;
		}
		setMessage("");
		Ecom2.PProLoading.show();
		PProFetch("command=ProfileMaintenanceHandler.ajaxcatsearch&" + parm + '=' + encodeURIComponent(value))
		.then(response => {
			return response.json();
		})
		.then(json => {
			let updatedFpInfo = { ...fpInfo };
			updatedFpInfo.root.PIPED_CATALOG.value = json.root.PIPED_CATALOG.value;
			updatedFpInfo.root.PIPED_CATALOG_DESCR.value = json.root.PIPED_CATALOG_DESCR.value;
			console.log("New fpInfo: ", updatedFpInfo);
			updateStateFromAjax(updatedFpInfo);
		})
		.finally(() => {
			Ecom2.PProLoading.hide();
		});
	};
	
	const cancelMaint = () => {
		Ecom2.PProLoading.show();
		window.location=`${fpInfo.root.postUrl}?command=catalogpage&name=profile&parm=nothing`;
	};

	const submitFormHandler = (_) => {
		Ecom2.PProLoading.show();
		const formData = new URLSearchParams();
		var strIDs = "";
		profileItemsArray.forEach(item => strIDs += "|" + item.id);
		if (strIDs.length > 0) strIDs = strIDs.substring(1); // remove extra pipe char
		
		PProPost(fpInfo.root.submitCommand, '<input type="hidden" name="PIPED_PROFILE" value="' + strIDs + '">');
	};
	
	/**** Start Drag and Drop events *****/
	const handleDragStart = (e) => {
		const { active } = e;
		const initialContainer = active.data.current?.sortable?.containerId;
		if (initialContainer == "profile")  {
			setActiveDragItem(profileItemsArray[_getArrayIndex(profileItemsArray, active.id)]);
		} else {
			setActiveDragItem(catalogItemsArray[_getArrayIndex(catalogItemsArray, active.id)]);
		}
		console.log("[handleDragStart] container: " + initialContainer + ", item=", activeDragItem);
	}

	const handleDragCancel = (e) => {
		const { active } = e;
		setActiveDragItem(null);
		console.log("[handleDragCancel] item=" + active.id);
	}

	/**
	 * @param {DragOverEvent} event 
	 */
	const handleDragOver = (e) => {
		const { active, over } = e;

		// Check if item is drag into unknown area
		if (!over || !active || !active.data.current || !over.data.current) {
			return;
		}

		const targetContainer = over.data.current?.sortable?.containerId;

		console.log("[handleDragOver] targetContainer=" + targetContainer);

		if (targetContainer == "trash") {
			return;
		} else if (targetContainer == "catalog")  {
			let index = _getArrayIndex(profileItemsArray, active.id);
			if (index != -1) {
				// Remove item from profile list
				let tempProfile = [ ...profileItemsArray ];
				tempProfile = tempProfile.filter((item) => { 
					return item.id != active.id; // keep everything that doesn't match
				});
				setProfileItemsArray(tempProfile); 
				console.log("[handleDragOver] Removing catalog item: ", active.id, " from profile list");
			}
			return;
		} else if (targetContainer == "profile") {
			let index = _getArrayIndex(profileItemsArray, active.id);
			if (index != -1) return; // item already in profile
			// We are moving an item to the profile list that wasn't already there
			index = _getArrayIndex(catalogItemsArray, active.id);
			if (index != -1) {
				let item = catalogItemsArray[index];
				console.log("[handleDragOver] Adding catalog item: ", item, " to profile list");
				let newIdx =  _getArrayIndex(profileItemsArray, over.id);
				let newArray = [item, ...profileItemsArray];
				if (newIdx != 0) newArray = arrayMove(newArray, 0, newIdx)
				setProfileItemsArray(newArray);
			}
		}
	}

	const handleDragEnd = (e) => { // e is DragEndEvent
		const { active, over } = e;
		setActiveDragItem(null);

		console.log("drag end!", e);

		// Check if item is drag into unknown area
		if (!over || !active || !active.data.current) {
			return;
		}

		const targetContainer = (over.id == "trash") ? "trash" : over.data.current?.sortable?.containerId;
		let initialContainer = "catalog";
		let index = _getArrayIndex(profileItemsArray, active.id);
		if (index != -1) {
			initialContainer = profileItemsArray[index].source;
		} 

		console.log("[handleDragEnd] initialContainer=" + initialContainer + ", targetContainer=" + targetContainer
			+ ", moved prod=" + active.id + ", over prod=" + over.id);

		let tempProfile = [ ...profileItemsArray ];
		if (targetContainer == "catalog" || (initialContainer == "catalog" && targetContainer == "trash")) {
			// dragging anything to the catalog side not allowed
			// dragging anything from the catalog to the trash is not allowed
			console.log("[handleDragEnd] Movement not allowed! Abort!.  Source is " + initialContainer + ", dest is " + targetContainer);
			return;
		} else if (targetContainer == "profile") {
			// Build new profile items array in the new order we need based on dropped index
			const oldIdx = _getArrayIndex(profileItemsArray, active.id);
			const newIdx = _getArrayIndex(profileItemsArray, over.id);
			if (oldIdx != newIdx) {
				tempProfile = arrayMove(tempProfile, oldIdx, newIdx);
			}
			if (initialContainer == "profile") {
				console.log("[handleDragEnd] profile to profile move");
			} else {
				console.log("[handleDragEnd] catalog to profile move");
				// remove item from catalog
				let tempCatalog = [ ...catalogItemsArray ];
				tempCatalog = tempCatalog.filter((item) => { 
					return item.id != active.id; // keep everything that doesn't match
				});
				setCatalogItemsArray(tempCatalog); 
				// change source of item from profile to catalog
				tempProfile[newIdx].source = "profile";
			}
		} else if (targetContainer == "trash" && initialContainer == "profile") {
			console.log("[handleDragEnd] trash move");
			// Delete the profile item
			tempProfile = tempProfile.filter((item) => { 
				return item.id != active.id; // keep everything that doesn't match
			});
		}
		setProfileItemsArray(tempProfile);
	};
	/**** End Drag and Drop events *****/

	// Uncomment to debug
	//if (!loading) console.log("ProfileMaint render, fpInfo:", fpInfo.root);

	let messageInfo = null;
	if (message) {
		messageInfo = <div className="alert alert-danger">{message}</div>;
	}

	return (
		<React.Fragment>
			<div className="blocktext page-heading font-size--l mt-4">Profile Maintenance</div>
			<div className="form__instructions text-color--gray4">
				{ loading ? <Skeleton count={2}/> : 
				<div>
					Use this page to modify your profile.&nbsp;&nbsp;<span className={fpInfo.root.HIDEINSERT.value}>Perform a keyword search to find items in the entire product catalog.&nbsp;&nbsp;</span>  
					<span>You may add new items to your profile by dragging from the left list to the right side list. Drag items to the trash can to remove them from the profile.&nbsp;&nbsp;</span> 
					<span>You change the order in which your profile items are displayed by dragging items to rearrange them. &nbsp;When you've finished making your changes, use the Submit Changes button. &nbsp;Your revised profile will become active the next time you begin an order.&nbsp;&nbsp;</span>
				</div>
				}
			</div>
			<hr className="my-4"/>	

			{messageInfo}

			<DndContext 
					onDragStart={handleDragStart}
					onDragOver={handleDragOver}
					onDragEnd={handleDragEnd}
					onDragCancel={handleDragCancel}>
				{ loading ? 
					<div className="profmaint">
						<div className="row">
	  						<div className="col-6">
	  							<Skeleton height="400px" width="400px"/>
	  						</div>
	  						<div className="col-6">
	  							<Skeleton height="400px" width="400px"/>
	  						</div> 
  						</div> 						
  					</div> :
  					<div className="profmaint">
	  					<div className="row">
	  						<div className="col-sm-12 row-cols-lg-3">
								<div id="profile_commodity_region" className={"mb-2 flex-grow-1 " + fpInfo.root.COMMHIDDEN.value}>
		 							<label className="d-block">Commodity Search</label>  
									<div className="select__wrapper">
										<BuildSelect 
											id={fpInfo.root.COMMODITY_DROPDOWN.id} 
											size={fpInfo.root.COMMODITY_DROPDOWN.size} 
											jsonArray={fpInfo.root.COMMODITY_DROPDOWN.value} 
											handleChange={pmCommSearch}
										/>
									</div>
								</div>
								<div id="profile_class_region" className={"mb-2 flex-grow-1 " + fpInfo.root.CLASSHIDDEN.value}>
		 							<label className="d-block">Class Search</label>  
									<div className="select__wrapper">
										<BuildSelect 
											id={fpInfo.root.CLASSSEARCH.id} 
											size={fpInfo.root.CLASSSEARCH.size} 
											jsonArray={fpInfo.root.CLASSSEARCH.value} 
											handleChange={pmClassSearch}
										/>
									</div>
								</div>
							</div>
						</div>
	  					<div className="row">
	  						<div className="col-sm">Keyword Search</div>
	  					</div>
	  					<div className="row">
	  						<div className="col-sm d-flex mb-auto">
	  							<input type="text" value={searchText} id="searchText" size="20" 
									onChange={(e) => setSearchText(e.target.value)}
									onKeyDown={(e) => pmSearchOnEnterKey(e)} 
								/>&nbsp;<input className="button ms-3" type="button" id="button_go" value="Go" onClick={profileMaintSearch} />
								<span className={"pl-2 " + fpInfo.root.SHOWALLCLS.value}>
									<input id="showall" className="button ms-3" type="button" name="Submit" value="Show All" onClick={profileMaintSearchAll} />
								</span>
	  						</div>
	  						<div className="col-sm">
								<Trash containerType="trash"/>
	  						</div>
	  					</div>
	  					<div className="row">
	  						<div className={"col-sm-6 flex-column " + fpInfo.root.HIDEINSERT.value}>
							    <label className="d-block">Search Results</label>  
	  							<DnDContainer items={catalogItemsArray} containerType="catalog"/>
	  						</div>
	  						<div className="col-sm-6 flex-column">
								<label className="d-block">Profile Items</label>  
	  							<DnDContainer items={profileItemsArray} containerType="profile"/>
	  						</div>  						
	  					</div>
						<DragOverlay dropAnimation={null}>
							{activeDragItem ? <Item id={activeDragItem.id} text={activeDragItem.text} source={activeDragItem.source} /> : null}
						</DragOverlay>
  					</div>
				}
				<div className="row">
					<div className="col-sm">
						{ loading ? 
							<div className="d-flex justify-content-end">
								<Skeleton height="45px"/>
								<Skeleton height="45px"/>
							</div> : 
							<div className="d-flex justify-content-end">
								<input className="button ms-3 mt-3" type="button" name="cancel" value="Cancel" id="button_cancel" onClick={cancelMaint} />
								<input className="button ms-3 mt-3" type="submit" value="Submit Changes" id="button_submit" onClick={submitFormHandler} />
							</div>
						}
					</div>
				</div>
			</DndContext>
	</React.Fragment>
	);
}